import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {observer} from 'mobx-react'

import InputTextarea from 'lib/control/InputTextarea'

@observer export default class DependentInputText extends Component {
    render() {
        const {state: _, ...props} = this.props
        const state = this.getFormState()

        return (
            <InputTextarea
                {...props}
                disabled={state.inputs_are_disabled}
                readOnly={state.inputs_are_readonly}
            />
        )
    }

    /**
     * @return {ProfileSettingsEditState}
     */
    getFormState = () => {
        return this.props.state
    }
}

DependentInputText.propTypes = {
    state: PropTypes.any.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.any,
    className: PropTypes.any,
}

